import "./styles/base.css";
import "./styles/interface.css";
import "./styles/responsive.css";
import "./styles/accessibility.css";
import "./styles/production.css";
import "./styles/controls.css";
import "./styles/recruiterExperience.css";
import "./styles/hiringOverview.css";
import "./styles/profileOverlay.css";

import "./styles/conciseLayout.css";
import "./styles/projectMedia.css";
import "./styles/mobile.css";
import "./styles/personalPortrait.css";
import { setupProjectMedia } from "./ui/projectMedia.js";
import { setupConciseLayout } from "./ui/conciseLayout.js";

const root = document.querySelector("#app");
let application = null;
setupConciseLayout(root);
const projectMedia = setupProjectMedia(root, {
  onOpenChange: open => application?.setProjectMediaOpen(open)
});
function readableFallback() {
  application?.destroy();
  application = null;
  root.classList.add("has-error", "is-ready", "profile-open");
  root.setAttribute("aria-busy", "false");
  [...root.children].forEach(el => { el.inert = false; });
  const profile = root.querySelector("#profile-overlay");
  profile.hidden = false;
  profile.setAttribute("aria-hidden", "false");
  root.querySelector("#fallback").hidden = true;
  root.querySelector("#loader").hidden = true;
  root.querySelector("#profile-close").hidden = true;
  const profileVideo = profile.querySelector("[data-profile-video]");
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    profileVideo?.play().catch(() => {});
  }
  profile.querySelectorAll("[data-profile-section]").forEach(button => {
    button.onclick = () => profile.querySelector("#" + button.dataset.profileSection)?.scrollIntoView({ block: "start" });
  });
}
try {
  const { createApp } = await import("./app.js");
  application = await createApp(root, { projectMedia });
  const hash = decodeURIComponent(location.hash.slice(1));
  if (hash && document.getElementById(hash)) {
    root.querySelector("#view-profile").click();
    requestAnimationFrame(() => document.getElementById(hash)?.scrollIntoView());
  }
} catch (error) {
  console.error("Portfolio 3D startup:", error);
  readableFallback();
}
root.querySelector("#world").addEventListener("webglcontextlost", event => {
  event.preventDefault();
  readableFallback();
});
window.addEventListener("pagehide", event => {
  if (!event.persisted) application?.destroy();
});
